<template lang="pug">
  #users.page
      Pagination(
          :page="$store.state.users.page"
          :total="$store.state.users.counter.total"
          :perPage="$store.state.users.limit"
          @click="pageHandler")
      .level
          .level-left
              .level-item
                  .control.has-icons-left.search-control
                      input.input(type="search" v-model="$store.state.users.search" placeholder="Search")
                      span.icon.is-left
                          i.fas.fa-search
          .level-right
              .level-item
                  .title.is-5.text-overflow Total: {{ $store.state.users.counter.total }}
      UserItem(v-bind="defaultUser" @update="update" @create="create")
      template(v-for="user in $store.state.users.list")
        UserItem(v-bind="user" @update="update" @removeDevice="removeDevice" @remove="remove" @addSub="addSub" @deleteSub="deleteSub" :key="user._id")
      Pagination(
          :page="$store.state.users.page"
          :total="$store.state.users.counter.total"
          :perPage="$store.state.users.limit"
          @click="pageHandler")
</template>

<script>
import UserItem from "@/components/UserItem";
import EditInput from "@/components/EditInput";
import Pagination from "@/components/Pagination";

const defaultUser = {
  _id: null,
  username: "",
  email: "",
  password: "",
  telegramID: "",
  subscriptions: [
    {
      _id: "0"
    }
  ],
  registrationOn: new Date().toString(),
  liveBot: false,
  tickerBot: false,
  raiseBot: false,
  crashBot: false,
  prematchBot: false
};

export default {
  name: "users",
  components: {
    Pagination,
    EditInput,
    UserItem
  },
  data: () => ({
    searchTimeout: null,
    defaultUser: { ...defaultUser }
  }),
  watch: {
    "$store.state.users.search"() {
      clearTimeout(this.searchTimeout);
      this.searchTimeout = setTimeout(() => {
        this.getUserList();
      }, 1000);
    },
    $route() {
      this.pageDetect();
      this.getUserList();
    }
  },
  methods: {
    getUserList() {
      return this.$store
        .dispatch("getUserList")
        .catch(text => {
          this.$notify({
            type: "error",
            title: "Get user list error",
            text
          });
        })
        .finally(() => {
          this.$store.commit("isLoading", {
            key: "users",
            status: false
          });
        });
    },
    pageDetect() {
      this.$store.state.users.page = parseInt(this.$route.params.page);
    },
    pageHandler(page) {
      this.$router.push({
        name: "Users",
        params: {
          page
        }
      });
    },
    create(obj) {
      if (confirm("Create user?")) {
        this.$store
          .dispatch("createUser", obj)
          .then(result => {
            Object.keys(defaultUser).forEach(
              key => (this.defaultUser[key] = defaultUser[key])
            );
            if (!result) {
              this.$notify({
                type: "error",
                title: "User has not created",
                text: "Check user data"
              });
            } else return this.getUserList();
          })
          .catch(text => {
            this.$notify({
              type: "error",
              title: "Create user error",
              text
            });
          });
      }
    },
    update(obj) {
      if (obj._id) {
        this.$store.dispatch("updateUser", obj).catch(text => {
          this.$notify({
            type: "error",
            title: "Save user error",
            text
          });
        });
      } else {
        Object.keys(obj).forEach(key => (this.defaultUser[key] = obj[key]));
      }
    },
    removeDevice({userId, id}) {
      this.$store.dispatch("removeDevice", {userId, id}).catch(text => {
        this.$notify({
          type: "error",
          title: "Remove device error",
          text
        });
      });
    },
    remove(_id) {
      if (confirm("Remove this user?")) {
        this.$store.dispatch("removeUser", _id).catch(text => {
          this.$notify({
            type: "error",
            title: "Remove user error",
            text
          });
        });
      }
    },
    addSub(payload) {
      this.$store.dispatch("addUserSubscription", payload).catch(text => {
        this.$notify({ type: "error", title: "Add subscription error", text });
      });
    },
    deleteSub(subId) {
      if (!confirm("Remove this subscription?")) return;
      this.$store.dispatch("deleteUserSubscription", subId).catch(text => {
        this.$notify({
          type: "error",
          title: "Remove subscription error",
          text
        });
      });
    }
  },
  mounted() {
    this.pageDetect();
  }
};
</script>
